import StatusBtn from '../status/StatusBtn'
import styles from './InvoicePreview.module.scss'

const InvoicePreview = () => {
	return (
		<div className={styles.invoiceCard}>
			{/* Header */}
			<div className={styles.header}>
				<h2>INVOICE</h2>
				<div className={styles.invoiceInfo}>
					<p>Invoice #: INV-001</p>
					<p>Date: 11/4/2025</p>
					<p>Due: N/A</p>
				</div>
			</div>

			{/* From / Bill To Section */}
			<div className={styles.infoSection}>
				<div className={`${styles.from} ${styles.infoSectionHead}`}>
					<h4>From:</h4>
					<p>Your Business Name</p>
					<p>Your Address</p>
					<p>Phone</p>
					<p>Email</p>
				</div>
				<div className={`${styles.billTo} ${styles.infoSectionHead}`}>
					<h4>Bill To:</h4>
					<p>Client Name</p>
					<StatusBtn label="Pending" variant="pending" />
				</div>
			</div>

			{/* Items Table */}
			<div style={{ overflowX: 'auto' }}>
				<table className={styles.table}>
					<thead>
						<tr>
							<th>Description</th>
							<th>Quantity</th>
							<th>Unit Price</th>
							<th>Amount</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Lorem ipsum dolor sit amet</td>
							<td>5</td>
							<td>10</td>
							<td>50</td>
						</tr>
						<tr>
							<td>consectetur adipiscing elit</td>
							<td>2</td>
							<td>20</td>
							<td>40</td>
						</tr>
					</tbody>
				</table>
			</div>

			{/* Totals */}
			<div className={styles.totals}>
				<div>
					<p>Subtotal:</p>
					<p>Tax(%):</p>
					<h4>Total:</h4>
				</div>
				<div>
					<p>90</p>
					<p>9</p>
					<h4>99</h4>
				</div>
			</div>
		</div>
	)
}

export default InvoicePreview
